import { useState, useEffect } from 'react';
import { subscribe, isStoreLoading } from '../data/store';

/**
 * Custom hook that subscribes to the global in-memory store.
 * Returns { version, loading }. Use this in components that render store data
 * to ensure they re-render automatically when data is fetched or updated.
 */
export const useSharedStore = () => {
  const [version, setVersion] = useState(0);
  const [loading, setLoading] = useState(isStoreLoading);

  useEffect(() => {
    setLoading(isStoreLoading);
    return subscribe(() => {
      setVersion((v) => v + 1);
      setLoading(isStoreLoading);
    });
  }, []);

  return { version, loading };
};
